import { NotFound } from '@/components/Message/NotFound';
import { twMerge } from 'tailwind-merge';

interface PdfPhotoListSectionProps {
  heading: React.ReactNode;
  children: React.ReactNode;
  containerClassName?: string;
  listClassName?: string;
  isNotFound?: boolean;
  notFoundText?: string;
}

export const PdfPhotoListSection = ({
  heading,
  children,
  containerClassName,
  listClassName,
  isNotFound,
  notFoundText,
}: PdfPhotoListSectionProps) => {
  return (
    <div className={twMerge('', containerClassName)}>
      {heading}
      <div
        className={twMerge(
          'grid grid-cols-4 gap-6',
          isNotFound && 'grid-cols-1 bg-gray-100 py-5 rounded-md',
          listClassName
        )}
      >
        {isNotFound ? (
          <NotFound
            text={notFoundText}
            containerClassName="gap-1"
            iconClassName="-mt-1.5 text-lg"
            textClassName="text-sm"
          />
        ) : (
          children
        )}
      </div>
    </div>
  );
};
